/**
 * Active-plan regenerate registry.
 *
 * The Preferences modal can be opened from global chrome (the sub-nav
 * "Preferences" tab, a `?prefs=1` deep link) that has no reference to whichever
 * plan the customer is currently viewing. When the customer is on a plan page,
 * that page registers its regenerate handler here so those global openers can
 * still offer "Save & regenerate" after a preferences edit. The plan page clears
 * the registration on unmount, so off-plan surfaces fall back to a plain "Save".
 *
 * A module-level registry (rather than React context) is deliberate: the modal
 * is rendered through a portal under `ModalProvider` at the app root, so it sits
 * OUTSIDE the plan screen's React subtree and can't read a context provider
 * placed there. This mirrors the app's other cross-tree signals
 * (`notifyPreferencesSaved`, `FUELING_PROFILE_CHANGED_EVENT`).
 */
let activeRegenerate: (() => void) | null = null;

export function setActivePlanRegenerate(fn: (() => void) | null): void {
  activeRegenerate = fn;
}

export function getActivePlanRegenerate(): (() => void) | null {
  return activeRegenerate;
}
